// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3YzB3","search":"Settings_search__o6bWP","filter":"Settings_filter__WiI9A"};